// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";
// Models

// Dto
import { NewPropertyDetailDTO } from "Globals/Models/DTO/NewPropertyDetailDTO";

export class NewPropertyDetailsModel extends ModelBase<NewPropertyDetailsModel, NewPropertyDetailDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public developmentName: string = "";
    @MobX.observable public propertySizeId: string = StoresInstance.Domain.PropertySizeStore.getSortedByOrdinal[0].id;
    // @MobX.observable public propertyTypeId: string = StoresInstance.Domain.PropertyTypeStore.getSortedByOrdinal[0].id;
    @MobX.observable public propertyTypeId: string | null = null;
    @MobX.observable public addressLine1: string = "";
    @MobX.observable public addressLine2: string = "";
    @MobX.observable public addressLine3: string = "";
    @MobX.observable public city: string = "";
    @MobX.observable public county: string = "";
    @MobX.observable public postcode: string = "";
    @MobX.observable public sameForApplicantTwo: boolean = false;
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;
    @MobX.observable public secondChoiceAddressLine1: string = "";
    @MobX.observable public secondChoiceAddressLine2: string = "";
    @MobX.observable public secondChoiceAddressLine3: string = "";
    @MobX.observable public thirdChoiceAddressLine1: string = "";
    @MobX.observable public thirdChoiceAddressLine2: string = "";
    @MobX.observable public thirdChoiceAddressLine3: string = "";

    @MobX.action
    public fromDto = (model: NewPropertyDetailDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.developmentName = model.developmentName;
            this.propertySizeId = model.propertySizeId;
            this.propertyTypeId = model.propertyTypeId;
            this.addressLine1 = model.addressLine1;
            this.addressLine2 = model.addressLine2;
            this.addressLine3 = model.addressLine3;
            this.city = model.city;
            this.county = model.county;
            this.postcode = model.postcode;
            this.sameForApplicantTwo = model.sameForApplicantTwo;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
            this.secondChoiceAddressLine1 = model.secondChoiceAddressLine1;
            this.secondChoiceAddressLine2 = model.secondChoiceAddressLine2;
            this.secondChoiceAddressLine3 = model.secondChoiceAddressLine3;
            this.thirdChoiceAddressLine1 = model.thirdChoiceAddressLine1;
            this.thirdChoiceAddressLine2 = model.thirdChoiceAddressLine2;
            this.thirdChoiceAddressLine3 = model.thirdChoiceAddressLine3;
        }
    };

    @MobX.action
    public toDto = (): NewPropertyDetailDTO => {
        let model: NewPropertyDetailDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            developmentName: this.developmentName,
            propertySizeId: this.propertySizeId,
            propertyTypeId: this.propertyTypeId,
            addressLine1: this.addressLine1,
            addressLine2: this.addressLine2,
            addressLine3: this.addressLine3,
            city: this.city,
            county: this.county,
            postcode: this.postcode,
            sameForApplicantTwo: this.sameForApplicantTwo,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
            secondChoiceAddressLine1: this.secondChoiceAddressLine1,
            secondChoiceAddressLine2: this.secondChoiceAddressLine2,
            secondChoiceAddressLine3: this.secondChoiceAddressLine3,
            thirdChoiceAddressLine1: this.thirdChoiceAddressLine1,
            thirdChoiceAddressLine2: this.thirdChoiceAddressLine2,
            thirdChoiceAddressLine3: this.thirdChoiceAddressLine3,
        };
        return model;
    };
}
